function readCssVar(name, fallback) {
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(name);
    value = value ? value.trim() : '';
    return value || fallback || '';
}

function colorWithAlpha(color, alpha, fallback) {
    try {
        return new fabric.Color(color).setAlpha(alpha).toRgba();
    } catch (e) {
        return fallback;
    }
}

module.exports = { readCssVar: readCssVar, colorWithAlpha: colorWithAlpha };
